const publicUrl = (
  typeof process !== "undefined" && process.env.PUBLIC_URL
    ? process.env.PUBLIC_URL
    : ""
).replace(/\/$/, "");

export const DATASET_PATH = `${publicUrl}/extensions_data.csv`;

export const APP_COPY = {
  title: "Developer Survey Analytics Dashboard",
  subtitle:
    "Comprehensive insights from Stack Overflow developer survey covering demographics, experience, technology trends, AI adoption, and job satisfaction",

  datasetLabel: "Stack Overflow Developer Survey (CSV)",

  datasetTooltip:
    "This dashboard analyzes Stack Overflow developer survey data to provide insights into global developer demographics, technology adoption patterns, AI tool usage, remote work trends, salary distributions, and job satisfaction across the developer community.",
};

export const DATASET_FIELDS_LIMIT = 80;
